<template>
  <div class="seo clearfix">
    <h1>雪帝资讯</h1>
    <p class="description fubiaoti">阅读最新的资讯与公告</p>
    <div class="main">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-xs-12" v-for="(app,index) in data" :key="index">
          <div class="articleBox">
            <router-link tag='a' class="huanchongZhong" :to="'/article/'+app.id">
              <div class="imgBox" v-lazy:background-image="app.imgpath">
                <img src="/static/images/zhanwei.jpg">
              </div>
              <h3>
                {{app.title}}
              </h3>
            </router-link>
            <p class="content">
              {{app.content}}
            </p>
          </div>
        </div>
        <div class="col-12 text-center">
          <br>
          <br>
          <div v-if='isLoading' class='dynamicMessage'>
            <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
          </div>
          <div v-if='isNodata' class='dynamicMessage'>
            — 没有更多了 —
          </div>
          <div v-if='isError' class='dynamicMessage'>
            — 请求失败 —
          </div>
          <br>
          <br>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import commons from '@/util/commons';
import { EventBus } from '@/util/eventBus'; // 引入事件总线

export default {
  name: 'Home',
  mixins: [generalMix],
  data () {
    return {
      type: 1,// 经销商,
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      allNumber: 0,
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: false
    }
  },
  computed:{
    whereObj() {
      return { page: this.page, type: this.type };
    }
  },
  methods:{
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = commons.scrollToButton() <= 150;
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          resultCommons.apiArticlelists(that, this.whereObj).then((ob) => {
            console.log(ob, this.page);
          });
        }
      };
    }
  },
  mounted() {
    this.scroll(this, window);
    EventBus.$emit('globalLoadingFun', { bool: true,loading:true });
    resultCommons.apiArticlelists(this, this.whereObj).then((ob) => {
      EventBus.$emit('globalLoadingFun', { bool: false,loading:false });
    });
    $('html').removeClass('scrollHide');
  },
  beforeDestroy() {
    // 清除事件
    window.onscroll = null;
  },
  components:{
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  }
}
</script>

<style scoped lang='less'>
.seo{
  margin-top: 100px;
  h1{
    color: #FFFFFF;
    margin-bottom: 40px;
    text-align: center;
  }
  .fubiaoti{
    color: rgba(255,255,255,0.5);
    text-align: center;
  }
  .main{
    margin-top: 80px;
    min-height: 60vh;
    div.articleBox{
      margin-bottom: 40px;
    }
  }
}
@media (max-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/article/Index.vue